<!-- Copyright (c) 2022 VMware, Inc. All rights reserved. VMware Confidential -->
<clr-date-container>
    <label>{{"date.filter.startDate" | vtranslate}}</label>
    <input type="date" clrDate id="startDate"
           [clrDate]="startDate"
           (clrDateChange)="onStartDateChange($event)">
</clr-date-container>
<clr-date-container>
    <label>{{"date.filter.endDate" | vtranslate}}</label>
    <input type="date" clrDate id="endDate"
           [clrDate]="endDate"
           (clrDateChange)="onEndDateChange($event)">
</clr-date-container>
